export default __webpack_public_path__ + "static/media/joanna.d0c2ae90.png";